"use strict";

const ConstructionFilters = function () {
  const filterResourceDataHandler = function (
    unfilteredData,
    filters,
    loadingScreen,
    smartFilters,
  ) {
    const filteredData = ResourceFilters.spatialFilters(unfilteredData, filters);

    return filterOffline(filteredData, filters, smartFilters);
  };

  var filterOffline = function (unfilteredData, filters, smartFilters) {
    return smartFilters ? smartFilters.filter(unfilteredData, filters) : unfilteredData;
  };

  var passSubGroupFilters = function (datum, filters) {
    let pass = true;
    const allElementsAreStrings = filters.subGroups?.every((element) => typeof element === "string")
      ? true
      : false;
    const datumGroupId = allElementsAreStrings ? datum.groupId?.toString() : datum.groupId;
    if (
      filters.subGroups?.length !== undefined &&
      !SmartFilterRegistry.getSummary()?.areAllCheckboxesChecked("subGroups")
    ) {
      pass = filters.subGroups.includes(datumGroupId);
    }

    return pass;
  };

  var passMonitoringDrainageFilters = function (datum, filters) {
    if (filters.drainsToSpatialGroupingId?.length) {
      return filters.drainsToSpatialGroupingId.includes(datum.monitoringName);
    }

    return true;
  };

  var passAreasDrainageFilters = function (datum, filters) {
    if (filters.drainsToAssesmentArea?.length) {
      return datum.assessmentMonitoringName.some((name) =>
        filters.drainsToAssesmentArea.includes(name),
      );
    }

    return true;
  };

  var passHighwaysFilter = function (datum, filters) {
    if (
      filters.highwayName?.length !== undefined &&
      !SmartFilterRegistry.getSummary()?.areAllCheckboxesChecked("highwayName")
    ) {
      return filters.highwayName.includes(datum.highwayName);
    }

    return true;
  };

  var passUrbanDrainageFilter = function (datum, filters) {
    if (filters.drainsToC?.length) {
      return filters.drainsToC.includes(datum.drainsToC);
    }

    return true;
  };

  var passCatchmentsFilter = function (datum, filters) {
    if (filters.catchmentName?.length) {
      return filters.catchmentName.includes(datum.catchmentName);
    }

    return true;
  };

  var passReceivingWaterFilter = function (datum, filters) {
    if (filters.drainsToRw?.length) {
      return filters.drainsToRw.includes(datum.drainsToRw);
    }

    return true;
  };

  var getFilterConfigs = function () {
    return {
      drainsToSpatialGroupingId: ["assessmentMonitoringName", "array"],
      drainsToAssesmentArea: ["assessmentMonitoringName", "array"],
      highwayName: "highwayName",
      implementerType: "implementerType",
      maintainerType: "maintainerType",
      landOwnership: "landOwnership",
      drainsToRw: "drainsToRw",
      drainsToC: "drainsToC",
      catchmentName: "catchmentName",
      phase: "phase",
      priority: "highPriority",
      subGroups: "groupId",
      associatedBmpTypes: ["associatedBmpTypes", "array"],
      projectType: "projectType",
      developmentType: "developmentType",
      otherFilters: (datum, filters) => {
        return ResourceFilters.passSearchStringFilter(datum, filters, [
          "projectIdentifier",
          "projectName",
          "streetAddress",
        ]);
      },
    };
  };

  return {
    filterOffline,
    filterResourceDataHandler,
    passReceivingWaterFilter,
    passUrbanDrainageFilter,
    passCatchmentsFilter,
    passHighwaysFilter,
    passMonitoringDrainageFilters,
    passAreasDrainageFilters,
    passSubGroupFilters,
    getFilterConfigs,
  };
};

module.exports = ConstructionFilters();

const SmartFilterRegistry = require("../filters/smartFilterRegistry");
const ResourceFilters = require("../filters/resourceFilters");
